import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faComment,
  faThumbsUp,
  faShare
} from '@fortawesome/free-solid-svg-icons';
import { Image as BsImage, Button } from 'react-bootstrap';
import VideoComponent from './VideoComponent';
import { useTranslate } from '@tolgee/react';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';
import { useSelector, useDispatch } from 'react-redux';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { COMPACT_MODE_HEIGHT } from '../contants';
import LinkPreview from './linkPreviewComponent';
import { FACEBOOK } from '../../../../config/constants';
import OnImagesLoaded from '../../../onImagesLoaded';
import PreviewImagesSkeleton from '../loaders/previewImagesSkeleton';
import PlatformIconSkeleton from '../loaders/platformIconSkeleton';
import ImportedPostsMediaPreview from './importedPostsMediaPreview';
import AltTagButton from './buttons/altTagsBtn';
export default function FacebookPostPreview({
  platformIcon = '',
  cropList = [],
  mediaFiles = [],
  postText = '',
  profileName = '',
  previewAssets,
  viewAssets,
  previewUrl = null,
  platform = null
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const imageIsPortrait = mediaFiles?.[0]?.width < mediaFiles?.[0]?.height;

  let multiImageContainerHeight = '388px';
  let img1Inset = '';
  let img2Inset = '';
  let img3Inset = '';
  let img4Inset = '';
  let img5Inset = '';
  const img6Inset = '';
  const img7Inset = '';
  const img8Inset = '';
  const img9Inset = '';
  const img10Inset = '';

  const containerRef = useRef(null);
  const highContainerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const {
    ui: { previewMode },
    created_in_lomavis
  } = useSelector((state: any) => state.lomavisCreator);

  useEffect(() => {
    if (highContainerRef.current) {
      setContainerWidth(highContainerRef.current.offsetWidth);
      // to handle page resize
      const getwidth = () => {
        setContainerWidth(highContainerRef.current.offsetWidth);
      };
      window.addEventListener('resize', getwidth);
      // remove the event listener before the component gets unmounted
      return () => {
        window.removeEventListener('resize', getwidth);
      };
    }
  }, []);

  if (mediaFiles) {
    if (mediaFiles.length === 1) {
      const ratio =
        Number(mediaFiles?.[0]?.height) / Number(mediaFiles?.[0]?.width);
      multiImageContainerHeight = containerWidth * ratio + 'px';
    } else if (mediaFiles.length === 2) {
      if (imageIsPortrait) {
        img1Inset =
          'calc(0% + 0px) calc(50% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img2Inset =
          'calc(0% + 0px) calc(0% + 0px) calc(0% + 0px) calc(50% + 1.01px)';
      } else {
        img1Inset = 'calc(0% + 0px) calc(0% + 0px) calc(50% + 1.01px)';
        img2Inset = 'calc(50% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
      }
    } else if (mediaFiles.length === 3) {
      if (imageIsPortrait) {
        img1Inset =
          'calc(0% + 0px) calc(33.3333% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img2Inset =
          'calc(0% + 0px) calc(0% + 0px) calc(50% + 1.01px) calc(66.6667% + 1.01px)';
        img3Inset =
          'calc(50% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px)';
      } else {
        img1Inset = 'calc(0% + 0px) calc(0% + 0px) calc(33.3333% + 1.01px)';
        img2Inset =
          'calc(66.6667% + 1.01px) calc(50% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img3Inset =
          'calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(50% + 1.01px)';
      }
    } else if (mediaFiles.length === 4) {
      if (imageIsPortrait) {
        img1Inset =
          'calc(0% + 0px) calc(33.3333% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img2Inset =
          'calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px) calc(66.6667% + 1.01px)';
        img3Inset =
          'calc(33.3333% + 1.01px) calc(0% + 0px) calc(33.3333% + 1.01px) calc(66.6667% + 1.01px)';
        img4Inset =
          'calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px)';
      } else {
        img1Inset = 'calc(0% + 0px) calc(0% + 0px) calc(33.3333% + 1.01px)';
        img2Inset =
          'calc(66.6667% + 1.01px) calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img3Inset =
          'calc(66.6667% + 1.01px) calc(33.3333% + 1.01px) calc(0% + 0px)';
        img4Inset =
          'calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px)';
      }
    } else if (mediaFiles.length >= 5) {
      if (imageIsPortrait) {
        img1Inset =
          'calc(0% + 0px) calc(50% + 1.01px) calc(40% + 1.01px) calc(0% + 0px)';
        img2Inset =
          'calc(0% + 0px) calc(0% + 0px) calc(40% + 1.01px) calc(50% + 1.01px)';
        img3Inset =
          'calc(60% + 1.01px) calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img4Inset = 'calc(60% + 1.01px) calc(33.3333% + 1.01px) calc(0% + 0px)';
        img5Inset =
          'calc(60% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px)';
      } else {
        img1Inset =
          'calc(0% + 0px) calc(50% + 1.01px) calc(50% + 1.01px) calc(0% + 0px)';
        img2Inset =
          'calc(50% + 1.01px) calc(50% + 1.01px) calc(0% + 0px) calc(0% + 0px)';
        img3Inset =
          'calc(0% + 0px) calc(0% + 0px) calc(66.6667% + 1.01px) calc(50% + 1.01px)';
        img4Inset =
          'calc(33.3333% + 1.01px) calc(0% + 0px) calc(33.3333% + 1.01px) calc(50% + 1.01px)';
        img5Inset =
          'calc(66.6667% + 1.01px) calc(0% + 0px) calc(0% + 0px) calc(50% + 1.01px)';
      }
    }
  }

  let count = 0;

  if (mediaFiles.length > 5) {
    count = mediaFiles.length - 5;
  }
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <div className="w-100 m-2">
      <Card className="w-100">
        <div className="d-flex justify-content-between p-2 px-3 align-items-center">
          <div className="d-flex flex-row align-items-center">
            <div className="w-50px h-50px">
              <OnImagesLoaded
                onLoaded={() => {}}
                placeholder={<PlatformIconSkeleton />}
              >
                <BsImage
                  src={platformIcon}
                  className="img-fluid w-100 h-100"
                  roundedCircle
                />
              </OnImagesLoaded>
            </div>
            <div className="d-flex flex-column align-items-start ms-2">
              <span className="fw-bold">{profileName}</span>
              <small className="text-black-50">
                {t('lomavisCreator.previewCards.just_now')}
              </small>
            </div>
          </div>
        </div>

        <div className="px-2 previewCardText d-flex align-items-start">
          <p className="py-2">
            {postText && (
              <span
                className="preview-text"
                style={{
                  color: 'black',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word'
                }}
                dangerouslySetInnerHTML={{ __html: postText }}
              />
            )}
          </p>
        </div>
        <div className="w-100">
          {mediaFiles.length === 0 && (
            <LinkPreview
              data={previewUrl}
              text={postText}
              platform={FACEBOOK}
            />
          )}
        </div>

        {created_in_lomavis && mediaFiles && mediaFiles.length > 0 && (
          <div
            className="asset_wrapper w-100"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <OnImagesLoaded
              onLoaded={() => {
                setIsImageLoaded(true);
              }}
              placeholder={<PreviewImagesSkeleton />}
            >
              {isImageLoaded && (
                <div
                  style={{ zIndex: 3 }}
                  className="d-flex gap-2 justify-content-center align-items-center position-absolute ms-auto me-3 mt-3 end-0"
                >
                  <div
                    className="viewButton btn btn-sm btn-bg-white border border-dark px-3"
                    style={{
                      zIndex: 3
                    }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => viewAssets()}
                  >
                    <i
                      style={{ padding: '0px' }}
                      className="fa-regular fa-eye text-dark"
                    ></i>
                  </div>

                  <AltTagButton platform={platform} />
                  <div
                    className="btn btn-sm btn-bg-white border border-dark cropEditBtn firstImageCropEditBtn"
                    style={{ zIndex: 3 }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => previewAssets()}
                  >
                    <span className="loading-indicator spinner-border spinner-border-sm d-none"></span>
                    <span>{t('lomavisCreator.preview.edit')}</span>
                  </div>
                </div>
              )}
              <div className="w-100">
                {mediaFiles &&
                  mediaFiles.length > 0 &&
                  mediaFiles?.[0]?.type == 'video' && (
                    <div>
                      <VideoComponent
                        posterUrl={mediaFiles?.[0]?.custom_thumbnail_url}
                        videoUrl={
                          mediaFiles?.[0]?.file || mediaFiles?.[0]?.video_url
                        }
                        styles={{
                          maxHeight:
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : '100%'
                        }}
                      />
                    </div>
                  )}
                <div ref={highContainerRef}>
                  {mediaFiles &&
                    mediaFiles.length > 0 &&
                    mediaFiles?.[0]?.type == 'image' && (
                      <div
                        className="position-relative overflow-hidden overflow-hidden"
                        ref={containerRef}
                        style={{
                          height:
                            mediaFiles.length === 1 &&
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : mediaFiles.length === 1
                              ? '100%'
                              : multiImageContainerHeight,
                          display: mediaFiles.length === 1 ? 'flex' : 'block',
                          justifyContent:
                            mediaFiles.length === 1 ? 'center' : 'initial',
                          alignItems:
                            mediaFiles.length === 1 ? 'center' : 'initial'
                        }}
                      >
                        {mediaFiles?.[0]?.image_url && (
                          <div
                            id="img-1"
                            className={
                              `${
                                mediaFiles.length == 1
                                  ? ''
                                  : 'position-absolute'
                              } ` + (mediaFiles.length >= 1 ? '' : 'd-none')
                            }
                            style={{
                              inset: img1Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover',
                                maxHeight:
                                  previewMode == PREVIEW_TYPE_COMPACT
                                    ? 500
                                    : '100%'
                              }}
                              src={mediaFiles?.[0]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[1]?.image_url && (
                          <div
                            id="img-2"
                            className={
                              'position-absolute ' +
                              (mediaFiles.length >= 2 ? '' : 'd-none')
                            }
                            style={{
                              inset: img2Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[1]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[2]?.image_url && (
                          <div
                            id="img-3"
                            className={
                              'position-absolute ' +
                              (mediaFiles.length >= 3 ? '' : 'd-none')
                            }
                            style={{
                              inset: img3Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[2]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[3]?.image_url && (
                          <div
                            id="img-4"
                            className={
                              'position-absolute ' +
                              (mediaFiles.length >= 4 ? '' : 'd-none')
                            }
                            style={{
                              inset: img4Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[3]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[4]?.image_url && (
                          <div
                            id="img-5"
                            className={
                              'position-absolute ' +
                              (mediaFiles.length >= 5 ? '' : 'd-none')
                            }
                            style={{
                              inset: img5Inset
                            }}
                          >
                            <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                              <div
                                className={
                                  'h1 mb-0 text-white ' +
                                  (mediaFiles.length > 5 ? '' : 'd-none')
                                }
                              >
                                +{count}
                              </div>
                            </div>
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[4]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[5]?.image_url && (
                          <div
                            id="img-6"
                            className={'position-absolute d-none'}
                            style={{
                              inset: img6Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[5]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[6]?.image_url && (
                          <div
                            id="img-7"
                            className={'position-absolute d-none'}
                            style={{
                              inset: img7Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[6]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[7]?.image_url && (
                          <div
                            id="img-8"
                            className={'position-absolute d-none'}
                            style={{
                              inset: img8Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[7]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[8]?.image_url && (
                          <div
                            id="img-9"
                            className={'position-absolute d-none'}
                            style={{
                              inset: img9Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[8]?.image_url}
                            />
                          </div>
                        )}

                        {mediaFiles?.[9]?.image_url && (
                          <div
                            id="img-10"
                            className={'position-absolute d-none'}
                            style={{
                              inset: img10Inset
                            }}
                          >
                            <img
                              className="img-fluid w-100 h-100"
                              style={{
                                objectFit: 'cover'
                              }}
                              src={mediaFiles[9]?.image_url}
                            />
                          </div>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </OnImagesLoaded>
          </div>
        )}

        {!created_in_lomavis && (
          <ImportedPostsMediaPreview
            platform={platform}
            mediaFiles={mediaFiles}
          />
        )}
        <div className="d-flex flex-row border-top justify-content-between px-2 border-top align-items-center">
          <div className="py-2">
            <FontAwesomeIcon className="me-2" icon={faThumbsUp} />
            {t('lomavisCreator.previewCards.like')}
          </div>
          <div className="py-2">
            <FontAwesomeIcon className="me-2" icon={faComment} />
            {t('lomavisCreator.previewCards.comment')}
          </div>
          <div className="py-2">
            <FontAwesomeIcon className="me-2" icon={faShare} />
            {t('lomavisCreator.previewCards.share')}
          </div>
        </div>
      </Card>
    </div>
  );
}
